import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class InboxService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetNotificationInboxList(input?: DataListModel): Observable<IAPIResponse> {
    let getNotificationInboxListUrl = WeGoConfig.API_GET_NOTIFICATION_INBOX_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getNotificationInboxListUrl = getNotificationInboxListUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getNotificationInboxListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ShowNotification(hashID: string): Observable<IAPIResponse> {
    let getNotificationInboxListUrl = WeGoConfig.API_GET_SHOW_NOTIFICATION + "?notificationInboxHashID=" + hashID;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getNotificationInboxListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/inbox/models/inbox.service.ts